// Tickable Mail: editor texts (en)
export default {
  // templates list
  "mail_tpl_intro": "The e-mails you send, from an automation or a campaign. Make them your own.",
  "mail_tpl_new": "New template",
  "mail_tpl_load_failed": "Couldn't load the templates",
  "mail_tpl_system": "System e-mails",
  "mail_tpl_system_intro": "These go out by themselves. Until you change them, visitors get our standard text in your branding.",
  "mail_tpl_default": "Standard",
  "mail_tpl_customized": "Customised, updated {date}",
  "mail_tpl_customize": "Customise",
  "mail_tpl_edit": "Edit",
  "mail_tpl_view": "View",
  "mail_tpl_reset": "Back to standard",
  "mail_tpl_reset_title": "Back to standard?",
  "mail_tpl_reset_confirm": "Your changes to '{name}' will be removed and visitors get the standard e-mail again.",
  "mail_tpl_own": "Your templates",
  "mail_tpl_empty": "No templates of your own yet. Start from an example and you'll have something nice in no time.",
  "mail_tpl_kind": "Kind of e-mail",
  "mail_tpl_kind_transactional": "About an order",
  "mail_tpl_kind_marketing": "Newsletter",
  "mail_tpl_kind_transactional_hint": "About an order or a visit. Goes to everyone it concerns.",
  "mail_tpl_kind_marketing_hint": "News and offers. Only goes to people who gave consent.",
  "mail_tpl_updated": "updated {date}",
  "mail_tpl_duplicate": "Duplicate",
  "mail_tpl_copy_of": "{name} (copy)",
  "mail_tpl_delete": "Delete",
  "mail_tpl_delete_confirm": "'{name}' will be deleted. This can't be undone.",
  "mail_tpl_delete_failed": "Couldn't delete",
  "mail_tpl_in_use": "This template is still in use",
  "mail_tpl_in_use_detail": "It's used in: {flows}. Remove it there first, then you can delete it.",
  "mail_tpl_start_from": "What would you like to start with?",
  "mail_tpl_blank": "Blank",
  "mail_tpl_blank_hint": "Just a text block, you build the rest",
  "mail_tpl_name": "Name",
  "mail_tpl_name_required": "Give your template a name so you can find it later.",
  "mail_tpl_create": "Create",
  "mail_tpl_create_failed": "Couldn't create the template",

  // editor: page
  "mail_editor_back": "Back to templates",
  "mail_editor_not_found": "This template doesn't exist (anymore)",
  "mail_editor_not_found_text": "It may have been deleted, or it belongs to another organisation.",
  "mail_editor_read_only": "View only",
  "mail_editor_read_only_text": "You can look at this e-mail and send yourself a test. Changing it needs the right to edit e-mails.",
  "mail_editor_unsaved": "Not saved",
  "mail_editor_preview": "Preview",
  "mail_editor_send_test": "Send test to me",
  "mail_editor_test_sent": "Test e-mail sent",
  "mail_editor_test_sent_to": "Have a look in your inbox: {email}",
  "mail_editor_test_failed": "Couldn't send the test e-mail",
  "mail_editor_save": "Save",
  "mail_editor_saved": "Saved",
  "mail_editor_save_failed": "Couldn't save",
  "mail_editor_fix_first": "Something isn't right yet. Check the red messages.",
  "mail_editor_leave_confirm": "You have changes that aren't saved yet. Leave anyway?",
  "mail_editor_preheader": "Preheader",
  "mail_editor_inspector": "Block settings",
  "mail_editor_nothing_selected": "Click a block in the e-mail to change it.",
  "mail_editor_keyboard_hint": "With the keyboard: Tab to a block, Enter to pick it, Alt + arrow up or down to move it.",
  "mail_editor_small_screen": "The editor needs a bigger screen, like a laptop. Here you can see what the e-mail looks like and send yourself a test.",
  "mail_editor_retry": "Try again",

  // palette and canvas
  "mail_editor_palette": "Blocks",
  "mail_editor_palette_content": "Content",
  "mail_editor_palette_dynamic": "From your orders and events",
  "mail_editor_palette_hint": "Click to add a block below the selected one, or drag it to where you want it.",
  "mail_editor_blocks": "Blocks in the e-mail",
  "mail_editor_block_tools": "Edit block",
  "mail_editor_drag": "Drag",
  "mail_editor_drag_hint": "Drag to move",
  "mail_editor_move_up": "Move up",
  "mail_editor_move_down": "Move down",
  "mail_editor_duplicate": "Duplicate",
  "mail_editor_delete": "Delete",
  "mail_editor_required_block": "This e-mail needs this block, so it can't be removed.",
  "mail_editor_has_error": "something isn't right here",
  "mail_editor_canvas_empty": "Your e-mail is still empty. Pick a block on the left to start.",
  "mail_editor_canvas_empty_readonly": "This e-mail has no blocks yet.",
  "mail_editor_footer_marketing": "Postal address and unsubscribe link are added here automatically",
  "mail_editor_empty_heading": "Type your heading here",
  "mail_editor_empty_text": "Type your text here",
  "mail_editor_empty_image": "Choose an image",
  "mail_editor_sample": "Sample",
  "mail_editor_sample_upcoming": "Fills itself",
  "mail_editor_sample_event": "Name of your event",
  "mail_editor_sample_when": "Sat 14 June · 20:00",
  "mail_editor_sample_where": "Venue · Street 1, Town",
  "mail_editor_sample_ticket": "Regular",
  "mail_editor_sample_ticket_child": "Child",
  "mail_editor_sample_promo": "Event {n}",

  // block names
  "mail_editor_block_heading": "Heading",
  "mail_editor_block_text": "Text",
  "mail_editor_block_image": "Image",
  "mail_editor_block_button": "Button",
  "mail_editor_block_divider": "Divider",
  "mail_editor_block_spacer": "Space",
  "mail_editor_block_event": "Event",
  "mail_editor_block_tickets": "Tickets",
  "mail_editor_block_payment_link": "Payment link",
  "mail_editor_block_order_link": "Link to order",
  "mail_editor_block_extras": "Add extras",
  "mail_editor_block_shop_button": "Shop button",
  "mail_editor_block_event_promo": "More events",

  // inspector
  "mail_editor_field_heading": "Heading",
  "mail_editor_field_size": "Size",
  "mail_editor_level_1": "Large",
  "mail_editor_level_2": "Small",
  "mail_editor_field_text": "Text",
  "mail_editor_field_image": "Image",
  "mail_editor_field_alt": "Description (alt text)",
  "mail_editor_field_alt_hint": "Many e-mail apps don't show images at first. Briefly describe what's in it.",
  "mail_editor_field_image_link": "Link on click (optional)",
  "mail_editor_field_width": "Width",
  "mail_editor_field_width_full": "Full width",
  "mail_editor_field_label": "Button text",
  "mail_editor_field_caption": "Caption",
  "mail_editor_field_note": "Line below the button",
  "mail_editor_field_pdf_label": "Link to the PDF",
  "mail_editor_pay_before_hint": "Add the Pay before variable to show the date.",
  "mail_editor_field_href": "Link",
  "mail_editor_field_href_hint": "Starts with https:// or mailto:, or pick a variable.",
  "mail_editor_divider_hint": "A thin line to separate parts of your e-mail.",
  "mail_editor_field_space": "How much space",
  "mail_editor_space_s": "Small",
  "mail_editor_space_m": "Medium",
  "mail_editor_space_l": "Large",
  "mail_editor_event_hint": "Shows the recipient's event with image, title and venue, plus the date and time of their own timeslot.",
  "mail_editor_tickets_hint": "Shows what was ordered, with a button to the order. In the confirmation the tickets are also attached as PDF.",
  "mail_editor_payment_link_hint": "Shows the reserved tickets with a button to pay.",
  "mail_editor_order_link_hint": "A button to the order page, where the tickets are.",
  "mail_editor_extras_hint": "The extras still on sale, with a button to add them. Without extras the block stays out.",
  "mail_editor_sample_extra": "Drinks package",
  "mail_editor_sample_extra_parking": "Parking",
  "mail_editor_shop_button_hint": "A button to your shop, or to the event when the e-mail is about one event.",
  "mail_editor_field_promo_title": "Title",
  "mail_editor_field_promo_mode": "Which events",
  "mail_editor_promo_upcoming": "Next up",
  "mail_editor_promo_pick": "Pick myself",
  "mail_editor_promo_upcoming_hint": "When sending we pick the next events for each recipient.",
  "mail_editor_promo_pick_hint": "Past events, and sold-out ones without a waitlist, are left out automatically.",
  "mail_editor_field_promo_events": "Events",
  "mail_editor_field_promo_events_placeholder": "Pick events",
  "mail_editor_field_promo_max": "At most",
  "mail_editor_field_promo_skip_bought": "Skip events the recipient already has tickets for",
  "mail_editor_field_promo_waitlist": "Sold out? Show the waitlist when it's on",

  // text editor
  "mail_editor_text_toolbar": "Formatting",
  "mail_editor_bold": "Bold",
  "mail_editor_italic": "Italic",
  "mail_editor_underline": "Underline",
  "mail_editor_link": "Link",
  "mail_editor_bullets": "Bullet list",
  "mail_editor_numbers": "Numbered list",
  "mail_editor_link_prompt": "Link (https:// or mailto:). Clear it to remove the link.",
  "mail_editor_insert_variable": "Variable",

  // image upload
  "mail_editor_image_choose": "Choose image",
  "mail_editor_image_replace": "Replace",
  "mail_editor_image_advice": "JPG, PNG or GIF. We make it smaller for you.",
  "mail_editor_image_wrong_type": "This file doesn't work in e-mails. Pick a JPG, PNG or GIF.",
  "mail_editor_image_gif_too_big": "This GIF is larger than 1 MB. That loads slowly in an e-mail, pick a smaller one.",
  "mail_editor_image_too_big": "Even resized this image is larger than 2 MB. Pick a smaller one.",

  // languages and translation
  "mail_editor_lang_label": "Language of the e-mail",
  "mail_editor_lang_source": "source",
  "mail_editor_lang_single": "Want to send e-mails in other languages too? Turn them on under",
  "mail_editor_lang_todo": "{n} texts not translated yet or out of date",
  "mail_editor_translate": "Translate",
  "mail_editor_translate_stale": "{n} fields out of date · update all",
  "mail_editor_translate_done": "Everything is translated",
  "mail_editor_translate_manual": "manual texts too ({n})",
  "mail_editor_translate_ok": "{n} texts translated",
  "mail_editor_translate_partial": "{done} texts translated, {failed} not. Please check those yourself.",
  "mail_editor_translate_failed": "Couldn't translate",
  "mail_editor_translate_rejected": "The translation didn't match the source text (for example a variable or link that changed).",
  "mail_editor_ai_tag_hint": "Translated automatically. If you change it, your text stays.",
  "mail_editor_update": "Update",
  "mail_editor_not_translated": "Not translated yet",
  "mail_editor_uses_source": "While this is empty, visitors get the source text.",

  // preview
  "mail_editor_preview_width": "Preview width",
  "mail_editor_preview_desktop": "Desktop",
  "mail_editor_preview_mobile": "Mobile",
  "mail_editor_preview_failed": "Couldn't load the preview",

  // validation
  "mail_editor_error_subject": "Fill in a subject.",
  "mail_editor_error_required_tickets": "The ticket confirmation needs a Tickets block.",
  "mail_editor_error_required_payment_link": "This e-mail needs a Payment link block.",
  "mail_editor_error_heading": "This heading is still empty.",
  "mail_editor_error_image_src": "Choose an image.",
  "mail_editor_error_image_alt": "Briefly describe what's in the image.",
  "mail_editor_error_button_label": "Put some text on the button.",
  "mail_editor_error_href": "This link won't work. Start with https:// or mailto:, or pick a variable.",
  "mail_editor_error_promo_events": "Pick at least one event.",

  // Return path, lock and tests (phase 2b)
  "mail_editor_back_generic": "Back",
  "mail_editor_back_campaign": "Back to your message",
  "mail_editor_locked_scheduled": "This mail is scheduled and fixed now. Want to change something? Cancel the sending first.",
  "mail_editor_locked_sent": "This mail has been sent and is fixed, so you always see what people got.",
  "mail_editor_locked_link": "To the message",
  "mail_editor_test_to": "To {email}",
  "mail_editor_block_discount_code": "Personal code",
  "mail_editor_discount_code_hint": "Everyone gets their own code of this invitation's discount here, working once, with a button that fills it in at the shop.",
}
